import { render, staticRenderFns } from "./TicketRender.vue?vue&type=template&id=50a6b0ea"
import script from "./TicketRender.vue?vue&type=script&lang=js"
export * from "./TicketRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports